import {useDispatch} from "react-redux";
import {useEffect} from "react";
import {useParams} from "react-router-dom";
import CreateBlogCanvas from "./CreateBlogCanvas";


export default function EditBlogCanvas() {
  const dispatch = useDispatch();

  const {blog_id} = useParams();

  useEffect(() => {

    return () => {
      //todo clear search
      // dispatch(resetManageBlogs());
      // dispatch(resetClearSearch());
    };
  }, []);




  return (
    <>
      <CreateBlogCanvas blogId={blog_id}/>
    </>
  );
}
